import http, { url } from '../../http'

const API_URL = "providers_contractors"

class proveedorContratistaAPI {

  async save(providers_contractors) {
    const response = await http(`${API_URL}/save`, 'POST', providers_contractors)
    return response
  }
 
  async getAll() {
    const response = await http(`${API_URL}`)
    return response
  } 

  async getActa() {
    return url(`highdirection`)
  } 

  async getAllIdentificationCompany(id,  page) {
    const response = await http(`${API_URL}/company/${id}?page=${page}`)
    return response
  } 
 
  async getRevision(id) {
    const response = await http(`${API_URL}/company/${id}`,  'POST')
    return response
  }

/*   async getAll(id, page, search) {
    const response = await http(`${API_URL}/company/${id}?page=${page}&search=${search}`,  'POST')
    return response
  }  */

  async getShow(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async update(id, contratista) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', contratista)
    return response
  }
  async deleteRevision(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

 
  
}

export default new proveedorContratistaAPI()